import React, { useEffect, useState, useRef } from "react";
import CommonHeader from "../../components/common-header";
import * as css from "./style.module.less";
import { fetchWecodeAppInfo, deleteWecodeAbility, updateWecodeAppInfo } from "./server/index";
import { useDispatch } from "redux-react-hook";
import useMappedState from "@src/utils/useMappedState";
import * as actions from "@src/actions/index";
import history from "@src/utils/history";
import { message, Spin, Form, Input, Button, Modal } from "@cloud/atom-ui";
import copy from 'copy-to-clipboard';
import CopyIcon from '@src/assets/copy.svg';
import { cloneDeep } from "lodash";

const ApplicationRobot = () => {
  const { appInfo } = useMappedState("root");
  const dispatch = useDispatch();
  const type = queryString("type");
  const [form] = Form.useForm();
  const [isEdit, setIsEdit] = useState(false);
  const [robotInfo, setRobotInfo] = useState({});
  const [editInfo, setEditInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const pageInitRef = useRef(false);

  const urlRule = [
    { required: true, message: '请输入消息接收地址!' },
    { pattern: /^(http|https):\/\/([\w.]+\/?)\S*/ig, message: "请输入正确格式" },
  ];

  // 点击编辑按钮
  const onEdit = () => {
    const info = cloneDeep(robotInfo);
    setIsEdit(v => !v);
    setEditInfo(info);
  };

  const editCancel = () => {
    Modal.confirm({
      content: "是否取消编辑？",
      onOk: () => {
        setIsEdit(v => !v);
        setEditInfo({});
        form.setFieldsValue({receiveUrl: robotInfo?.receiveUrl})
      }
    });
  };

  // 保存
  const editSave = () => {
    form?.validateFields()
      .then(() => {
        updateWecodeAppInfo(editInfo, appInfo.aliasName)
          .then(res => {
            if (res.status === 1) {
              const info = cloneDeep(editInfo);
              setRobotInfo(info);
              setIsEdit(v => !v);
            } else {
              message.warning(res.errMsg || "更新机器人功能信息失败");
            }
          })
          .catch(err => {
            console.log(err);
            message.warning("更新机器人功能信息失败");
          });
      })
      .catch(error => {
        console.error(error);
      })
  };

  // 删除机器人
  const deleteWecodeApp = () => {
    deleteWecodeAbility(appInfo.aliasName)
      .then(res => {
        if (res.status === 1) {
          dispatch(
            actions.setAppInfo({
              ...appInfo,
              abilityList: appInfo.abilityList?.filter(i => i !== "robot")
            })
          );
          history.push(
            `/${type}/appdetailV2/addAppCapabilities?id=${appInfo?.aliasName}&type=${type}`
          );
        } else {
          message.warning(res.errMsg || "删除机器人的应用能力失败");
        }
      })
      .catch(err => {
        console.log(err);
        message.warning("删除机器人的应用能力失败");
      });
  };

  // 复制地址
  const onCopy = (address) => {
    copy(address);
    message.success('已复制');
  };

  const renderCopyIcon = (address) => {
    return (
      <div className={css['copy_icon']} onClick={() => onCopy(address)}>
        <img className={css['img_icon']} src={CopyIcon} />
      </div>
    )
  };

  const onChangeUrl = (e) => {
    const info = cloneDeep(editInfo);
    info.receiveUrl = e?.target?.value;
    setEditInfo(info);
  };
  
  useEffect(() => {
    if (pageInitRef.current || appInfo === undefined) {
      return;
    }
    if (!appInfo?.abilityList?.includes("robot")) {
      history.push(
        `/${type}/appdetailV2/addAppCapabilities?id=${appInfo?.aliasName}&type=${type}`
      );
      return;
    }
    setLoading(true);
    fetchWecodeAppInfo(appInfo.aliasName)
      .then(res => {
        if (res.status === 1) {
          setRobotInfo(res?.data || {});
        } else {
          message.warning(res.errMsg || "查询机器人功能基本信息失败");
        }
        setLoading(false);
        pageInitRef.current = true;
      })
      .catch(err => {
        setLoading(false);
        pageInitRef.current = true;
        console.log(err);
      });
  }, [appInfo]);

  const mainConfigRender = () => {
    if (loading) {
      return (
        <Spin
          style={{
            width: "100%",
            height: "calc(100% - 107px)",
            display: "flex",
            justifyContent: "center"
          }}
          spinning={loading}
        />
      );
    }
    return (
      <div className={css["main"]}>
        <Form form={form} name="robot" autoComplete="off">
          {isEdit ? (
            <>
              <Form.Item
                label="消息接收地址"
                name="receiveUrl"
                rules={urlRule}
              >
                <Input defaultValue={editInfo?.receiveUrl} maxLength={200} placeholder='http://或者https://' onChange={onChangeUrl} addonAfter={renderCopyIcon(editInfo?.receiveUrl)} />
              </Form.Item>
              <div className={css["edit_btn"]}>
                <Button type="primary" className={css["save"]} onClick={editSave}>
                  保存
                </Button>
                <Button className={css["cancel"]} onClick={editCancel}>
                  取消
                </Button>
              </div>
            </>
          ) : (
            <>
              <Form.Item
                label="消息发送地址"
              >
                <div className={css['addresses_content']}>
                  <div className={css['item_content']}>{robotInfo?.sendUrl}</div>
                  {robotInfo?.sendUrl && renderCopyIcon(robotInfo?.sendUrl)}
                </div>
              </Form.Item>
              <Form.Item
                label="消息接收地址"
              >
                <div className={css['addresses_content']}>
                  <div className={css['item_content']}>{robotInfo?.receiveUrl}</div>
                  {robotInfo?.receiveUrl && renderCopyIcon(robotInfo?.receiveUrl)}
                </div>
              </Form.Item>
            </>
          )}
        </Form>
      </div>
    );
  };

  return (
    <div className={css["container"]}>
      <CommonHeader
        headerStyle={{ marginBottom: "30px" }}
        title="机器人"
        titleEditShow={!isEdit}
        titleEditClick={() => onEdit()}
        showRightBtn={!isEdit}
        btnClick={deleteWecodeApp}
        customizedTip={<span>机器人能力发布后将对全员可见</span>}
      />
      {mainConfigRender()}
    </div>
  )
};

export default ApplicationRobot;